import { render, staticRenderFns } from "./UploadEdit.vue?vue&type=template&id=7304c7c7&scoped=true&"
import script from "./UploadEdit.vue?vue&type=script&lang=js&"
export * from "./UploadEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7304c7c7",
  null
  
)

export default component.exports